import { useEffect, useState } from 'react';

import { Input } from '@/components/ui/Input';
import { Box } from '@/components/ui/layout/layout';

export type NumericInputProps = {
  value: number;
  ariaLabel: string;
  min: number;
  max: number;
  step: number;
  disabled?: boolean;
  onCommit: (value: number) => void;
};

/** Redisplays the normalized value accepted by `SettingsStore` after each edit */
export const NumericInput = (props: NumericInputProps) => {
  const { value, ariaLabel, min, max, step, disabled, onCommit } = props;
  const storedText = `${value}`;
  const [text, setText] = useState(storedText);

  useEffect(() => setText(storedText), [storedText]);

  const commit = () => {
    const amount = Number.parseFloat(text);
    // Accept the numeric prefix; the store normalizes it, and this input
    // always redisplays the stored value, so invalid input simply restores it
    if (Number.isFinite(amount)) onCommit(amount);
    setText(storedText);
  };

  return (
    <Box className="w-[5.25rem] shrink-0">
      <Input
        type="number"
        inputMode="decimal"
        inputSize="sm"
        className="text-right"
        aria-label={ariaLabel}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.currentTarget.blur();
        }}
      />
    </Box>
  );
};
